// axios
import { Message} from "element-ui";
import router from '../router/index';
import axios from 'axios';
// axios.defaults.baseURL = 'http://supackage.kcnd0593.cn/api'
axios.defaults.baseURL = 'http://subpack.99xieli.cn/api'
// axios.defaults.baseURL = 'https://localhost:44333/api'

axios.defaults.headers['Authorization'] = 'Bear '+window.localStorage.getItem("token");
var requests = function(url,params,method='GET',contentType=0){
  let type = 'application/x-www-form-urlencoded'
  if(contentType == 1){
    type = 'application/json'
  }
  return axios({
    url:url,
    method: method,
    headers:{
      'Content-Type':type,
      'Authorization':'Bear '+window.localStorage.getItem("token")
    },
    data:params
  }).then(res=>{
    console.log(res)
    return res;
    //return res.data;
  }).catch(res=>{
    console.log(res.response.data.ExceptionMessage,res.response.data.ExceptionMessage == "登录过期，请重新登录！")
    if(res.response.data.ExceptionMessage == "登录过期，请重新登录！" || res.response.data.ExceptionMessage == "无效Token，请尝试重新登录！"){
      console.log(router)
      router.push({path:'/login'})
    }
    Message({
      message: res.response.data.ExceptionMessage,
      type: 'error',
      duration:2000
    })
    return res;
  })
}

 export default requests;